import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import * as Urls from 'src/constants/EndpointUrls';
// CSS
import styles from './FileImport.scss';

// CSV ダウンロードカラム説明
const DownloadColumnDetail = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-wrap-l">
      <div className="l-overflow-scroll">
        <table className="m-table-description">
          <thead>
            <tr>
              <th className="m-table-description-item-name">{t('features.EmployeePays.components.DownloadColumnDetail.data_item_name')}</th>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.description')}</th>
              <th className="m-table-description-example">{t('features.EmployeePays.components.DownloadColumnDetail.example')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.staff_code')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                {t('features.EmployeePays.components.DownloadColumnDetail.format')}：{t('features.EmployeePays.components.DownloadColumnDetail.alphanumeric')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.data_imported_based_on_staff_code_so_be_sure_to_enter_it_correctly')}
              </td>
              <td>111</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.last_name')}</th>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.can_leave_this_blank_because_data_is_based_on_staff_code')}</td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.Yamada')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.first_name')}</th>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.can_leave_this_blank_because_data_is_based_on_staff_code')}</td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.Taro')}</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.payment_date')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                dd/mm/yyyy<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.error_will_occure_if_payment_date_and_input_payment_date_does_not_match')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.go_to_month_you_want_to_upload_from_salary_list_and_click_provision_and_deduction_item_CSV_import_again')}
              </td>
              <td>25/01/2025</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.salary_rules_group_name')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                {t('features.EmployeePays.components.DownloadColumnDetail.error_will_occur_if_salary_rules_name_with_the_closing_date_payment_date_in_display_set_and_input_salary_rules_group_name_does_not_match')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.go_to_month_you_want_to_upload_from_salary_list_and_click_provision_and_deduction_item_CSV_import_again')}
              </td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.for_fulltime_employee')}</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.provision_item_name')}<br />{t('features.EmployeePays.components.DownloadColumnDetail.deduction_item_name')}
              </th>
              <td>
                <a href={Urls.CLIENT_PAYROLL_RULES_GROUP_LIST} className="u-txt-link">
                  {t('features.EmployeePays.components.DownloadColumnDetail.salary_rules')} ＞{t('features.EmployeePays.components.DownloadColumnDetail.provision_deduction_items')}
                </a>
                {t('features.EmployeePays.components.DownloadColumnDetail.can_upload_provision_items_and_deduction_items_set_here')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.warning')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.leave_automatically_calcuated_provision_and_deduction_items_such_as_insurance_premiums_blank')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.items_with_input_value_will_not_be_automatically_calculated')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.click_back_to_before_manual_input_button_on_salary_edit_page_to_calculate_automatically_again')}
              </td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.basic_salary')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.remarks')}</th>
              <td>
                {t('features.EmployeePays.components.DownloadColumnDetail.input_detail_to_be_shown_in_payslip_remark_within_255_characters')}<br />{t('features.EmployeePays.components.DownloadColumnDetail.line_breaks_are_not_reflected')}
              </td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.basic_salary_updated_with_the_raise_in_April')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DownloadColumnDetail;
